<div class="container-fluid">
  <div class="d-flex flex-column flex-sm-row">
    <mat-form-field>
      <mat-icon matPrefix color="primary">search</mat-icon>
      <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Rechercher" />
    </mat-form-field>
    <span class="spacer"></span>
    <button mat-mini-fab appTooltip="Ajouter un groupe" class="ml-auto m-3 white" color="primary" (click)="add()">
      <mat-icon aria-label="Ajouter un groupe">add</mat-icon>
    </button>
  </div>
  <div>
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="code">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Code</th>
        <td mat-cell *matCellDef="let row" class="main">{{ row.code }}</td>
      </ng-container>
      <ng-container matColumnDef="category">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Categorie</th>
        <td mat-cell *matCellDef="let row">{{ row.category }}</td>
      </ng-container>
      <ng-container matColumnDef="display.name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Nom</th>
        <td mat-cell *matCellDef="let row">{{ row.display.name }}</td>
      </ng-container>
      <ng-container matColumnDef="display.order">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Ordre</th>
        <td mat-cell *matCellDef="let row">{{ row.display.order }}</td>
      </ng-container>
      <ng-container matColumnDef="display.collapsed">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Repliée par défaut ?</th>
        <td mat-cell *matCellDef="let row">{{ row.display.collapsed | booleanFormat }}</td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let row">
          <button mat-icon-button [matMenuTriggerFor]="actions" [matMenuTriggerData]="{data:row}">
            <mat-icon>more_vert</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator [pageSize]="paging.pagingPageSize" [pageSizeOptions]="paging.pagingPageSizeOptions"
      showFirstLastButtons></mat-paginator>
  </div>
</div>

<mat-menu #actions="matMenu">
  <ng-template matMenuContent let-row="data">
    <ul class="menu-actions">
      <li>
        <a (click)="edit(row)"><mat-icon color="primary">create</mat-icon><span class="text">Modifier le
            groupe</span></a>
      </li>
      <li>
        <a (click)="confirmDelete(row)">
          <mat-icon color="primary">delete_forever</mat-icon>
          <span class="text">Supprimer le groupe</span>
        </a>
      </li>
    </ul>
  </ng-template>
</mat-menu>
